import { memo } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { InputText, InputTextProps } from './index';

type InputHookFormProps = InputTextProps & {
  name: string;
  control?: any;
};

export const InputTextHookForm = memo<InputHookFormProps>(
  function InputHookForm({
    name,
    control: _control,
    ...inputProps
  }: InputHookFormProps) {
    let control = _control;

    if (!control) {
      const { control: contextControl } = useFormContext();
      control = contextControl;
    }

    const {
      field: { value, ref, ...fieldProps },
      fieldState,
    } = useController({
      name,
      control,
      defaultValue: inputProps?.defaultValue,
    });

    return (
      <InputText
        testId={name}
        value={value ?? ''}
        error={!!fieldState.error}
        helperText={fieldState?.error?.message}
        {...inputProps}
        {...fieldProps}
        inputRef={ref}
      />
    );
  }
);
